import { insertImage, getAtomicEntityInfo, deprecated } from "lib/helpers";
import { MetaBlock } from "./MetaBlock";
import { extname } from "lib/helpers";
import { RichUtils } from "draft-js";

const defaultOptions = {};

/**
 * @returns {DraftEditorPlugin}
 */
export function createMetaPlugin(options = defaultOptions) {
	return {
		getBlockRenderInfo(block, store) {
			const entityInfo = getAtomicEntityInfo(block, store);
			if (entityInfo && entityInfo.entityType === 'META') {
				return {
					component: MetaBlock,
					editable: false,
					props: { ...entityInfo, store },
				};
			}
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/metaPlugin/createMetaPlugin.js